import { render, staticRenderFns } from "./Follow.vue?vue&type=template&id=ef399a8e&scoped=true"
import script from "./Follow.vue?vue&type=script&lang=ts"
export * from "./Follow.vue?vue&type=script&lang=ts"
import style0 from "./Follow.vue?vue&type=style&index=0&id=ef399a8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef399a8e",
  null
  
)

export default component.exports